import React from 'react';
import SmsNumbers from '../../notifications/SmsNumbers';
import { STAFF_EVENTS } from '../../../lib/notificationEvents';
import { useOrg } from '../../../hooks/useOrg';

// Settings → Notifications: the signed-in staff member's own text numbers
// and what each one hears about. Each person sets their own; a front-desk
// line and a doctor's cell can split the events between them.
export default function NotificationsTab() {
  const { currentOrg } = useOrg();
  return (
    <div className="bg-elevated border border-theme rounded-[14px] p-5">
      <h2 className="text-[15px] font-bold text-primary-c mb-1">Text notifications{currentOrg?.name ? ` · ${currentOrg.name}` : ''}</h2>
      <SmsNumbers
        key={currentOrg?.id}
        orgId={currentOrg?.id}
        events={STAFF_EVENTS}
        intro={`Your mobile numbers for ${currentOrg?.name || 'this practice'} and what each one gets texted about — only this practice's referrals and appointments, never another organization's. Texts never include patient details. Each team member sets their own.`}
      />
    </div>
  );
}
